import {CapsulableEntity, EntityCapsule, EntityCapsuleProps} from "../entity/capsule.tsx";
import {iconForEntityType} from "../fa.tsx";
import {useTranslation} from "react-i18next";

export interface TruckCapsuleProps extends Omit<EntityCapsuleProps, "entity"> {
    truck: CapsulableEntity | undefined;
}

export function TruckCapsule(props: TruckCapsuleProps) {
    const {truck: inTruck, ...rest} = props;
    const {t} = useTranslation();
     let truck: CapsulableEntity = inTruck ?? {displayName: t("unknown")};
    if (!truck.icon) {
        truck = {...truck, icon: iconForEntityType("truck")};
    }
    return <EntityCapsule entity={truck} {...rest}/>;
    // const capsule =
    //     <EntityCapsule entity={truck} {...rest}/>;
    // if (truck.id && linkify) {
    //     return <RouterJoyLink underline="hover" to="/truck/$id/timeline" params={{id: truck.id}} color={color}>
    //         {capsule}
    //     </RouterJoyLink>
    // } else {
    //     return capsule;
    // }
}

